import { take } from 'rxjs';

import { Component, inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ILeadRequestForm } from '@leads/customer-facing/models/domain/lead-request.domain';
import { IDropdownOption } from '@shared/components/forms/dropdown-control/dropdown-control.component';
import { IPopover } from '@shared/models/popover';
import { ModalService } from '@shared/services/modal/modal.service';

import { ImportClientModalComponent } from '../components/import-client-modal/import-client-modal.component';
import { IImportClient, PropertySelectType } from '../models/domain/lead-request.domain';

@Component({
	template: '',
})
export abstract class BaseLeadRequestCreateComponent {
	@Input() leadRequestForm: FormGroup<ILeadRequestForm>;
	@Input() serviceTypes: Array<IDropdownOption>;

	private modalService = inject(ModalService);

	openImportClient(): void {
		const modalRef = this.modalService.open(ImportClientModalComponent, false, 'lg');
		const componentInstance = modalRef.componentInstance as ImportClientModalComponent;
		componentInstance.clientSelected.pipe(take(1)).subscribe((clientImport: IImportClient) => {
			this.leadRequestForm.controls.mobileNumber.setValue(clientImport.selectedClient.client.clientNumber);
			this.leadRequestForm.controls.contactDetails.controls.name.setValue(clientImport.selectedClient.client.clientName);
			this.leadRequestForm.controls.contactDetails.controls.emailAddress.setValue(clientImport.selectedClient.client.clientEmail);
			if (clientImport.propertySelectType === PropertySelectType.EXISTING && clientImport.selectedClientProperty) {
				this.leadRequestForm.controls.installationAddress.patchValue(clientImport.selectedClientProperty);
			} else {
				this.leadRequestForm.controls.installationAddress.reset();
			}
			this.leadRequestForm.markAsDirty();
		});
	}

	contactInfoPopOver: IPopover = {
		triggerText: {
			desktop: "What's this?",
			mobile: "What's this?",
		},
		title: 'Contact Information',
		description: 'Create a new lead by selecting an existing contact or manually creating a new one below.',
		icon: 'bi-info-circle-fill',
	};
}
